import React, { useState, useEffect } from 'react';
import makeStyles from '@mui/styles/makeStyles'; // Giữ lại từ file cũ
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Hidden from '@mui/material/Hidden';
import Box from '@mui/material/Box';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
// import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlinedIcon'; // Bỏ nếu không dùng
import UpgradeOutlinedIcon from '@mui/icons-material/UpgradeOutlined'; // Giữ lại nếu dùng trong menu Partner Account
import CardMembershipOutlinedIcon from '@mui/icons-material/CardMembershipOutlined';
import { Button, Divider, Typography } from '@mui/material'; // Bỏ MenuList nếu không dùng trực tiếp
import { getDisplayPhone } from '../../ckcore/core/Telcos';
import ck_logo_white from '../../ckcore/images/chuyenkhoan_logo_white.png';
import ck_bg from '../../ckcore/images/chuyenkhoan_bg.svg';
import Colors from '../../ckcore/core/Colors';
import Config from '../../ckcore/core/Config';
import TxStatus from '../../ckcore/core/TxStatuses';
// import TxTypes from '../../ckcore/core/TxTypes'; // Bỏ vì không dùng API cũ
// import User from '../../ckcore/core/User'; // Bỏ nếu không dùng User.getIdentity()
// import Roles, { getRoleName, getRoleStatus } from '../../ckcore/core/Roles'; // Bỏ vì dùng partnerList mới
// import { getStatusColor, getTxTimeText } from '../../ckcore/core/TxUtils'; // Bỏ nếu không dùng
import { getSubscriptionPackageName } from '../subscription/PricingTable'; // Giữ lại cho menu Partner Account
import moment from 'moment';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useKeycloak } from '@react-keycloak/web'; // Thêm để lấy token

// Bỏ hàm compare cũ vì partnerList mới đã được sort trong fetchPartnerList

export default function CkAppBar(props) {
  const classes = useStyles(); // Sử dụng useStyles từ file gốc
  const { keycloak } = useKeycloak(); // Thêm hook keycloak
  const { userObj, partnerObj, showApp, switchPartnerCallback, openLogoutDialog, refreshCallback /* giữ lại nếu cần */, logoutCallback /* giữ lại nếu cần */ } = props;

  // Sử dụng partnerList từ API mới thay vì userObj.roles
  const [partnerList, setPartnerList] = useState([]);
  // const [loading, setLoading] = useState(false); // Có thể dùng lại nếu muốn có loading indicator khi fetch partner

  const largeScreen = useMediaQuery('(min-width:960px)');

  // === State quản lý menu như file gốc ===
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuOpen, setMenuOpen] = React.useState(false); // Menu tài khoản user
  const [showPartnerAccount, setShowPartnerAccount] = React.useState(false); // Menu CKCoin/Subscription
  const [showActionList, setShowActionList] = React.useState(false); // Menu Tạo yêu cầu
  const [showPartnerList, setShowPartnerList] = React.useState(false); // Menu chọn Partner
  // =========================================

  // Fetch partner list mới khi component mount hoặc user thay đổi
  useEffect(() => {
    if (userObj?.username && keycloak?.token) {
      fetchPartnerList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userObj?.username, keycloak?.token]); // Thêm dependency

  // === Hàm fetch partner list mới ===
  const fetchPartnerList = async () => {
    // setLoading(true); // Bật loading nếu cần
    try {
      const url = Config.getServerURL() + "/api/v2/partners/list"; // API endpoint mới
      const rawResponse = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${keycloak.token}` // Sử dụng token từ keycloak
        },
        body: JSON.stringify({})
      });
      const response = await rawResponse.json();
      if ([TxStatus.SUCCESS, TxStatus.HTTP_SUCCESS].includes(response.statusId)) {
        const fetchedPartners = response.partners || [];
        // Sắp xếp danh sách đối tác theo partnerId trước khi set state
        const sortedPartners = fetchedPartners.sort((a, b) => a.partnerId - b.partnerId);
        setPartnerList(sortedPartners);
        console.log("Partner list loaded (v2 API)");
      } else if (response.statusId === TxStatus.TIMEOUT && logoutCallback) {
         console.log("User session timeout (v2 API). Need to login again");
         logoutCallback(); // Gọi logoutCallback nếu có
      } else {
         console.error("Failed to fetch partner list (v2 API):", response);
      }
    } catch (error) {
      console.error("listPartners fetch error (v2 API):", error);
    } finally {
      // setLoading(false); // Tắt loading nếu cần
    }
  };
  // ==================================

  // === Các hàm quản lý menu như file gốc ===
  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuOpen(false);
    setShowActionList(false);
    setShowPartnerAccount(false);
    setShowPartnerList(false);
  };

  // Mở menu tài khoản user
  const handleMenuOpen = (event) => {
    handleMenuClose(); // Đảm bảo các menu khác đã đóng
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  // Mở menu Tạo yêu cầu
  const handleActionOpen = (event) => {
    handleMenuClose(); // Đảm bảo các menu khác đã đóng
    setAnchorEl(event.currentTarget);
    setShowActionList(true);
  };

  // Mở menu CKCoin/Subscription
  const handlePartnerAccountOpen = (event) => {
    handleMenuClose(); // Đảm bảo các menu khác đã đóng
    setAnchorEl(event.currentTarget);
    setShowPartnerAccount(true);
  };

  // Mở menu chọn Partner
  const handlePartnerOpen = (event) => {
    handleMenuClose(); // Đảm bảo các menu khác đã đóng
    setAnchorEl(event.currentTarget);
    setShowPartnerList(true); // Luôn hiển thị nếu có danh sách > 1
    // Không cần load danh sách ở đây nữa vì đã load ở useEffect
  };
  // =========================================

  // Close menu and show app (như file gốc)
  const requestShowApp = (appId, action) => {
    handleMenuClose();
    showApp(appId, action);
  };

  // === Hàm xử lý chọn partner mới ===
  const handleSwitchPartner = (partnerId) => {
    handleMenuClose(); // Đóng menu
    if (switchPartnerCallback) {
        switchPartnerCallback(partnerId); // Gọi callback mới
    } else {
        console.warn("switchPartnerCallback is not defined in props");
    }
    // Bỏ hàm activeRole cũ
  };
  // ================================

   // Hàm xử lý logout
   const handleLogout = () => {
    handleMenuClose();
    if (openLogoutDialog) {
      openLogoutDialog();
    } else {
       console.warn("openLogoutDialog is not defined in props");
    }
  }

  // Get partner short name (như file gốc)
  const getPartnerShortName = (partnerName) => {
    if (!partnerName) {
      return '';
    }
    // Sử dụng biến largeScreen đã khai báo
    if (!largeScreen && partnerName.length > 6) {
      return partnerName.substring(0, 6) + "..";
    }
    return partnerName;
  };

  // RETURN VIEW (Giữ cấu trúc JSX gần giống file gốc nhất có thể)
  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar style={{ minHeight: 48 }}>
        {/* Phần hiển thị logo/tên đối tác */}
        {(userObj?.partnerId > 0 && partnerObj) ? (
          <Box className={classes.partnerName}>
            {partnerObj.logo && (
              <img className={classes.partnerLogo} src={partnerObj.logo} alt={partnerObj.name || 'Partner logo'} onClick={() => requestShowApp("MEMBERS")} />
            )}
            <Typography style={{ paddingTop: 3 }} variant="h6" display="inline" onClick={() => requestShowApp("MEMBERS")}>
              {getPartnerShortName(partnerObj.name)}
            </Typography>
            {/* Sử dụng partnerList.length thay vì userRoles.length */}
            {(partnerList.length > 1) && (
              <IconButton size="small" /* Đổi size thành small cho gọn */ onClick={handlePartnerOpen} style={{ color: Colors.BG_WHITE, marginLeft: 4 }}>
                <ArrowDropDownOutlinedIcon />
              </IconButton>
            )}
            {/* Menu chọn partner */}
            {/* anchorEl được quản lý chung, open dùng state riêng showPartnerList */}
            <Menu
                id="ck-partner-list-menu" // Thêm id cho menu
                anchorEl={anchorEl}
                open={showPartnerList}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} // Giữ lại từ code trước
                transformOrigin={{ vertical: 'top', horizontal: 'right' }} // Giữ lại từ code trước
                PaperProps={{ style: { marginTop: '4px', zIndex: 2000 } }} // Giữ lại từ code trước
            >
              {/* Lặp qua partnerList đã fetch và sort */}
              {partnerList.map((p) => (
                <MenuItem key={p.partnerId} onClick={() => handleSwitchPartner(p.partnerId)} selected={p.partnerId === userObj.partnerId}>
                  {/* Hiển thị partnerId và name từ partnerList */}
                  {p.partnerId} - {p.name}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        ) : (
          <img className={classes.logo} onClick={() => requestShowApp("MEMBERS")} src={ck_logo_white} alt="Chuyển Khoản" />
        )}

        {/* Phần user profile và actions (như file gốc) */}
        <Box className={classes.userProfile}>
          {/* Nút tạo yêu cầu */}
          {(partnerObj?.subscription?.package === 'large') && (
            <Button variant="outlined" size="small" color="inherit" // Đổi màu cho phù hợp theme AppBar
              style={{ marginRight: 20, borderColor: 'rgba(255, 255, 255, 0.5)', color: Colors.BG_WHITE }} // Style từ code trước
              startIcon={<AddOutlinedIcon />}
              onClick={handleActionOpen}
            >
              <Hidden mdDown>Tạo yêu cầu</Hidden>
            </Button>
          )}

          {/* Nút CK Coin */}
          <Button variant="outlined" size="small" color="inherit" // Đổi màu cho phù hợp theme AppBar
            style={{ marginRight: 12, borderColor: 'rgba(255, 255, 255, 0.5)', color: Colors.BG_WHITE }} // Style từ code trước
            startIcon={<CardMembershipOutlinedIcon />}
            onClick={handlePartnerAccountOpen}
          >
            <strong style={{ color: Colors.LIGHT_GREEN }} /* Đổi màu cho dễ đọc */>
                <Hidden mdDown>CKCOIN: </Hidden>
                {partnerObj?.ckCoin ?? 0}
            </strong>
          </Button>

          {/* Nút User Icon */}
          <IconButton color="inherit" aria-label="logout" onClick={handleMenuOpen} size="large">
            <AccountCircleIcon />
          </IconButton>
        </Box>

        {/* Menu Tài khoản User (như file gốc, dùng menuOpen) */}
        {/* anchorEl được quản lý chung, open dùng state riêng menuOpen */}
        <Menu
            id="ck-account-menu"
            anchorEl={anchorEl}
            keepMounted // Giữ lại từ file gốc
            open={menuOpen}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} // Giữ lại từ code trước
            transformOrigin={{ vertical: 'top', horizontal: 'right' }} // Giữ lại từ code trước
            PaperProps={{ style: { marginTop: '4px', zIndex: 2000, minWidth: 220 } }} // Giữ lại từ code trước
        >
          {userObj && ( // Kiểm tra userObj trước khi hiển thị
            <MenuItem style={{ whiteSpace: 'normal', cursor: 'default' }} disableRipple>
              <Box>
                <Box><strong>{userObj.name}</strong></Box>
                <Box>SĐT: {getDisplayPhone(userObj.phone)}</Box>
                <Box>Email: {userObj.email}</Box>
                <Divider style={{ marginTop: 8 }} />
              </Box>
            </MenuItem>
          )}
          <MenuItem onClick={() => requestShowApp("PROFILE")}><span style={{ color: Colors.DARK_BLUE }}>Sửa thông tin</span></MenuItem>
          <MenuItem onClick={() => requestShowApp("PASSWORD")}><span style={{ color: Colors.DARK_BLUE }}>Đổi mật khẩu</span></MenuItem>
          <MenuItem onClick={handleLogout}><span style={{ color: Colors.ORANGE }}>Đăng xuất</span></MenuItem>
        </Menu>

        {/* Menu Tạo Yêu Cầu (như file gốc, dùng showActionList) */}
        {/* anchorEl được quản lý chung, open dùng state riêng showActionList */}
        <Menu
            id="ck-action-menu"
            anchorEl={anchorEl}
            keepMounted // Giữ lại từ file gốc
            open={showActionList}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} // Giữ lại từ code trước
            transformOrigin={{ vertical: 'top', horizontal: 'right' }} // Giữ lại từ code trước
            PaperProps={{ style: { marginTop: '4px', zIndex: 2000 } }} // Giữ lại từ code trước
        >
          <MenuItem onClick={() => requestShowApp("ORDERS", "createSaleOrder")}><span style={{ color: Colors.DARK_BLUE }}>Tạo đơn bán hàng</span></MenuItem>
          <MenuItem onClick={() => requestShowApp("ORDERS", "paymentRequest")}><span style={{ color: Colors.DARK_BLUE }}>Yêu cầu thanh toán</span></MenuItem>
          <MenuItem onClick={() => requestShowApp("ORDERS", "createPurchaseOrder")}><span style={{ color: Colors.DARK_BLUE }}>Tạo đơn mua hàng</span></MenuItem>
          <MenuItem onClick={() => requestShowApp("ORDERS", "purchaseRequest")}><span style={{ color: Colors.DARK_BLUE }}>Yêu cầu chi phí</span></MenuItem>
        </Menu>

        {/* Menu CKCoin/Subscription (như file gốc, dùng showPartnerAccount) */}
        {/* anchorEl được quản lý chung, open dùng state riêng showPartnerAccount */}
        <Menu
            id="ck-partner-account-menu" // Đổi id cho rõ ràng
            anchorEl={anchorEl}
            keepMounted // Giữ lại từ file gốc
            open={showPartnerAccount}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} // Giữ lại từ code trước
            transformOrigin={{ vertical: 'top', horizontal: 'right' }} // Giữ lại từ code trước
            PaperProps={{ style: { marginTop: '4px', zIndex: 2000 } }} // Giữ lại từ code trước
        >
          {partnerObj && ( // Kiểm tra partnerObj trước khi hiển thị
            <MenuItem style={{ whiteSpace: 'normal', cursor: 'default' }} disableRipple>
              <Box>
                <Box><strong>Gói {partnerObj.subscription ? getSubscriptionPackageName(partnerObj.subscription.package) : 'Dùng thử'}</strong></Box>
                <Box style={{ fontSize: 14 /* Chỉnh nhỏ lại chút */ }}>Hạn dùng: {partnerObj.subscription ? moment(partnerObj.subscription.expired).format('DD/MM/YYYY') : 'N/A'}</Box>
                <Box style={{ fontSize: 14 }}>Còn lại {partnerObj.ckCoin ?? 0} CKCoin</Box>
                <Divider style={{ marginTop: 8 }} />
              </Box>
            </MenuItem>
          )}
          <MenuItem onClick={() => requestShowApp("MEMBERS", "upgrade")}>
            {/* Có thể thêm icon UpgradeOutlinedIcon ở đây nếu muốn */}
            {/* <UpgradeOutlinedIcon fontSize="small" sx={{ mr: 1 }} /> */}
            <span style={{ color: Colors.DARK_BLUE }}>Gia hạn dịch vụ</span>
          </MenuItem>
          {/* Chỉ hiển thị mua CKCoin nếu đã có gói subscription */}
          {(partnerObj?.subscription?.package) &&
            <MenuItem onClick={() => requestShowApp("MEMBERS", "ckcoin")}>
              <span style={{ color: Colors.DARK_BLUE }}>Mua thêm CKCoin</span>
            </MenuItem>
          }
          <MenuItem onClick={() => { /* Thêm hành động gửi góp ý */ handleMenuClose(); /* ví dụ: */ window.open('mailto:support@example.com'); }}>
            <span style={{ color: Colors.DARK_BLUE }}>Gửi góp ý / hỗ trợ</span>
          </MenuItem>
        </Menu>

      </Toolbar>
    </AppBar>
  );
}

// Styles (giữ nguyên từ file gốc)
const useStyles = makeStyles((theme) => ({ // đổi homeTheme thành theme cho chuẩn
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: "#37517f",
    backgroundImage: `url(${ck_bg})`,
    width: "100%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    // backgroundOrigin: "center", // Thuộc tính này thường không cần thiết
  },
  logo: {
    height: 40,
    cursor: "pointer"
  },
  partnerName: {
    cursor: "pointer",
    display: "flex",
    // flexDirection: "row", // Mặc định của flex là row
    alignItems: "center", // Thêm để căn giữa logo và text theo chiều dọc
    // justifyContent: "center", // Bỏ nếu không muốn căn giữa toàn bộ box này
    whiteSpace: "nowrap"
  },
  partnerLogo: {
    height: 24,
    width: 24,
    // margin: 'auto', // Bỏ margin auto
    marginRight: 8, // Giữ lại margin phải
  },
  userProfile: {
    marginLeft: 'auto',
    display: 'flex', // Thêm để các nút trong này xếp hàng ngang
    alignItems: 'center', // Thêm để căn giữa các nút theo chiều dọc
  }
}));